/* eslint-disable*/

import React from 'react';
import PropTypes from 'prop-types';
import { Grid, SimpleGrid, Input, Button } from '../../../components/index';
import CalculadoraPagamento from './CalculadoraPagamento';
import UploadArquivosMsg from '../templates/UploadArquivosMsg';
import { obterTipoMensagem } from './tiposMensagens';
import Masks from '../../../utils/masks';
import { tiposMensagem } from '../../../utils/listsSelect';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';
import { ehPapelObservadorPagamento } from '../../../utils/helpers';
import User from '../../../domain/User';
import {
  doPost,
  doGet,
  validateObject,
  trataMensagensErro,
  trataMensagemSucesso,
  doMultipartFormPost,
} from '../../../utils/requests';

const rowStyle = {
  marginBottom: '10px',
  fontSize: '16px',
};

const spanStyle = {
  margin: '0px',
  position: 'relative',
  color: '#44707B',
  padding: '5px',
  fontSize: '14px',
};

const pemissoesAcaoPrincipal = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps',
'requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];

const VAZIO = '';
const PAGAMENTO_GRU_FORA_COMPREV = 'Pagamento efetuado fora do COMPREV (GPS ou GRU cobrança)';

class NovaMensagem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState(props);
  }
  
  getInitialState = () => ({
    readOnly: false,
    opcaoNovaMensagem: null,
    arquivos: [],
    sucessoUpload: false,
    mensagem: {
      idControlePagamento: null,
      idMensagem: null,
      motivo: null,
      textoMensagem: null,
      valorParcial: this.props.valorParcial,
      dataPagamento: null,
      email: null,
      informacoesContato: null,
      cpf: null,
      nomeUsuario: null,
      tipoMensagem: null,
      tipoEmissor: null,
      documentosMensagem: [],
      valorJuros: null,
      valorMulta: null,
      valorCobrancaAtualizado: null,      
      idGruNossoNumero: null,
    },
    validadeCampos: {
      textoMensagem: false,
      email: false,
      camposCalculadora: true,
    },
    naoReconhecoEstaCobranca: 0,
    cancelarCobranca: 0,
    listaGrusDoPagamento: [],
    idParticipanteLogado: null,
    listaTiposMensagens: [],
  });

  componentDidMount() {
    this.montarListaGrusDoPagamento();
    this.buscarParticipantePeloCnpjLogado();
  }

  montarListaGrusDoPagamento = () => {
    let gru = {};
    let lista = [];
    if (this.props.infoPagamento && this.props.infoPagamento.grusTO.length > 0 ) {
      this.props.infoPagamento.grusTO.forEach((item) => {
        gru = { value: item.idGruNossoNumero, label: `${item.idGruNossoNumero} gerada em ${item.dataCriacao} com vencimento em ${item.dataVencimento}` };
        lista.push(gru);
      });
    }
    gru = { value: 0, label: PAGAMENTO_GRU_FORA_COMPREV };
    lista.push(gru);
    this.setState({ listaGrusDoPagamento: lista });
  }

  handleSuccessBuscaPeloCnpjLogado = (response) => {
    let id = '';
    if (response.data) {
      id = response.data.codigo;
      this.setState({
        idParticipanteLogado: id,
      });
    }
  }

  handleErrorBuscaPeloCnpjLogado = () => (
    ''
  );

  buscarParticipantePeloCnpjLogado = () => {
    const usuarioLogado = new User(localStorage.getItem('jwt'));
    const cnpj = usuarioLogado.cnpjDoPapel();
    if (cnpj) {
      doGet(
        `participantes-compensacao/${cnpj}`,
        this.handleSuccessBuscaPeloCnpjLogado,
        this.handleErrorBuscaPeloCnpjLogado,
      );
    }    
  }

  mostraTextoJustificativa() {
    return this.state.opcaoNovaMensagem === '5' ||
    this.state.opcaoNovaMensagem === '7' ? 'Justificativa' : 'Observação do analista';
  }

  filtrarTiposMensagem = () => {
    const lista = [];
    const mensagensPossiveisDoBackend = this.props.infoPagamento.novasMensagensPossiveis;
    //const mensagensPossiveisDoBackend = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];
    // const { idParticipanteLogado } = { ...this.state };
    // const usuarioLogado = new User(localStorage.getItem('jwt'));
    // const ehRecebedor = usuarioLogado.cnpjDoPapel() === undefined || (usuarioLogado.cnpjDoPapel() === this.props.infoPagamento.cnpj);
    // const ehControleDebitoPendente = this.props.tipoControle !== 'controle-pagamentos';

    // const ehRecebedor = (idParticipanteLogado === this.props.infoPagamento.entidadeRecebedora ||
    // (ehControleDebitoPendente && this.props.infoPagamento.codigoParticipanteLogado === '01000') );
    const ehRecebedor = (this.props.infoPagamento.codigoParticipanteLogado === this.props.infoPagamento.entidadeRecebedora);

    if(mensagensPossiveisDoBackend && mensagensPossiveisDoBackend.length > 0) {
      mensagensPossiveisDoBackend.filter((item)=>(!ehRecebedor && ((item >= 3 && item <= 5) || (item === 9 || item === 12 || item === 15 || item === 16) && item !== 11))).map((item) => (lista.push(tiposMensagem[item-1] )));
      mensagensPossiveisDoBackend.filter((item)=>(ehRecebedor && ((!(item >= 3 && item <= 5)) || (item == 10 || item == 11 || item == 13 || item == 14) ))).map((item) => (lista.push(tiposMensagem[item-1] )) );
    }
    return lista;
  }

  handleComboTipoMensagemChange = (changeObj) => {
    const { mensagem } = { ...this.state };
    const { validadeCampos } = { ...this.state}

    validadeCampos.dataPagamento = changeObj.value !== '3';

    if (changeObj.value === '2') {
      validadeCampos.valorParcial = false;
    } else if (changeObj.value !== '2' && (mensagem.valorParcial !== '' && mensagem.valorParcial !== null)) {
      mensagem.valorParcial = null;
      validadeCampos.valorParcial = true;
    }

    if (changeObj.value !== '3' && (mensagem.dataPagamento !== '' && mensagem.dataPagamento !== null)) {
      mensagem.dataPagamento = null;
      validadeCampos.dataPagamento = true;
    }

    if (changeObj.value === '4') {
      validadeCampos.camposCalculadora = false;
    } else {
      validadeCampos.camposCalculadora = true;
    }

    if (changeObj.value === '9') {
      if(mensagem.idGruNossoNumero !== null){
        mensagem.idGruNossoNumero = null;
      }
    }

    if (changeObj.value === '10') {
      validadeCampos.valorCobrancaAtualizado = false;
    } else {
      validadeCampos.valorCobrancaAtualizado = true;
    }

    if (changeObj.value === '11' /*&& this.state.cancelarCobranca === 1*/) {
      this.state.cancelarCobranca === 0;
      validadeCampos.valorCobrancaAtualizado = true;
    }

    if (changeObj.value === '12') {
      // this.montarListaGrusDoPagamento();
      validadeCampos.idGruNossoNumero = false;
    } else {
      validadeCampos.idGruNossoNumero = true;
    }
    
    if (changeObj.value === '15') {
      validadeCampos.camposCalculadora = false;
    } else {
      validadeCampos.camposCalculadora = true;
    }

    this.setState({
      ...this.state,
      opcaoNovaMensagem: changeObj.value,
      validadeCampos: validadeCampos,
    });
  }

  handleTextChange = (changeObj, name) => {
    const { mensagem } = { ...this.state };
    // const { validadeCampos } = { ...this.state };

    this.setState({
      ...this.state,
        mensagem: {
          ...mensagem,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      }
    });
  }

  handleChangeValorCobrancaAtualizado = (name) => {
    const { mensagem } = { ...this.state };

    if ((name === 'naoReconhecoEstaCobranca' || name === 'cancelarCobranca') &&
    (mensagem.valorCobrancaAtualizado !== null || mensagem.valorCobrancaAtualizado !== VAZIO)) {
      mensagem.valorCobrancaAtualizado = VAZIO;
      this.setState({
        validadeCampos: {
          ...this.state.validadeCampos,
          valorCobrancaAtualizado: true,
        },
      });  
    }
    this.setState({
      mensagem: {
        ...mensagem,
      },
    });
  }

  handleChangeCheckbox = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    }, this.handleChangeValorCobrancaAtualizado(name));
  }

  handleArquivostChange = (changeObj) => {
    // const { mensagem } = { ...this.state };
    //const { infoPagamento } = { ...this.state };
    //const { validadeCampos } = { ...this.state };

    this.setState({
      ...this.state,
      arquivos: changeObj.value,
    });
  }

  handleKeyUp = (e) => {
    let retorno = e.target.value;
      if (retorno.indexOf('_') !== -1) {
        retorno = retorno.toString().replace('_', '');
      }
      retorno = retorno.toString().replace(/\D/g, '');
      retorno = retorno.toString().replace(/(\d)(\d{11})$/, '$1.$2');
      retorno = retorno.toString().replace(/(\d)(\d{8})$/, '$1.$2');
      retorno = retorno.toString().replace(/(\d)(\d{5})$/, '$1.$2');
      retorno = retorno.toString().replace(/(\d)(\d{2})$/, '$1,$2');
      e.target.value = retorno;

    return retorno;
  }

  replaceMoeda = (valor, id) => {
    const { mensagem } = { ...this.state };
    let valorReplace = valor;
    if (valorReplace) {
      if (typeof (valorReplace) !== 'number') {
        let valor = valorReplace;
        valor = valor.replace(/\./g, '').replace(/,/g, '.');
        if (id === 1) {
          mensagem.valorParcial = Number(valor);
        }
        if (id === 2) {
          mensagem.valorCobrancaAtualizado = Number(valor);
        }
        this.setState({
          mensagem: {...mensagem },
        })
      }
    }
  }

  handleSaveButton = () => {
    const { mensagem } = { ...this.state };
    const { validadeCampos } = { ...this.state };
    
    //Object.keys(validadeCampos).forEach((key) => {
    //  validadeCampos[key] = true;
    //});

    if (mensagem.valorParcial !== null && mensagem.valorParcial !== '') {
      this.replaceMoeda(mensagem.valorParcial, 1);
    } else {
      mensagem.valorParcial = null;
    }
    if (mensagem.valorCobrancaAtualizado && mensagem.valorCobrancaAtualizado !== '') {
      this.replaceMoeda(mensagem.valorCobrancaAtualizado, 2);
    } else {
      mensagem.valorCobrancaAtualizado = null;
    }
    if(mensagem.idGruNossoNumero === '0') {
      mensagem.idGruNossoNumero = null;
    }

    this.setState({
      validadeCampos,
     // requestPesquisa: null,
    }, () => this.fazerRequestNovaMensagem());
  };

  formularioProntoParaEnvio = () => (
    validateObject(this.state.validadeCampos)
  );

  fazerRequestNovaMensagem = () => {
    if (this.formularioProntoParaEnvio()){
      const {mensagem} = {...this.state};
      const usuario = User.logged();
      const urlPosMensagem = 'mensagem-pagamento-participante';

      mensagem.idControlePagamento = this.props.infoPagamento.idControlePagamento;
      mensagem.cpf = usuario.data.id;
      mensagem.nomeUsuario = usuario.data.name;
      mensagem.tipoMensagem = Number(this.state.opcaoNovaMensagem);
      mensagem.arquivos = this.state.arquivos;

      doPost(
        urlPosMensagem,
        mensagem,
        this.trataSucessoResponseEnvio,
        this.trataErrosResponse, 
      );
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);  
    }
  }

  trataSucessoResponseEnvio = (response) => {
    if(this.state.arquivos.length > 0) {
      this.uploadFile(response);
    } else {
      this.props.acaoBuscarPagamento(this.props.infoPagamento.idControlePagamento);
      trataMensagemSucesso(['Mensagem inserida.']);
    }
    this.setState({ opcaoNovaMensagem: null });
  }

  trataErrosResponse = (error) => {
    const { validadeCampos } = { ...this.state };
    if (error) {
      const { data } = { ...error };
      if (error.status === 400) {
        if (data.erros && data.erros.length >= 1) {
          data.erros.forEach((erro) => {
            if (erro.atributo in validadeCampos) {
              validadeCampos[[erro.atributo]] = false;
            }
          });
          this.setState({
            ...this.state, validadeCampos,
          });
        }
      }
    }
  }

  uploadFile = (response) => {
    const { arquivos } = { ...this.state };
    const { mensagem } = { ...this.state };
    const url = 'documentos-mensagem';     
    if (arquivos.length > 0) {
      for (let i = 0, docs = arquivos.length; i < docs; i += 1) {
        const body = {
          idControlePagamento: this.props.infoPagamento.idControlePagamento,
          idMensagem: response.data.idMensagem,
          legenda: arquivos[i].legenda,
          documento: arquivos[i],
        };
        doMultipartFormPost(
          url,
          body,
          this.handleDocumentSent,
          this.handleFailDocumentSent,
        );
      }
    }
  }

  handleDocumentSent = () => {
    this.props.acaoBuscarPagamento(this.props.infoPagamento.idControlePagamento);
    trataMensagemSucesso(['Documento(s) anexado(s) com sucesso.']);
  }

  handleFailDocumentSent = () => {
    this.props.acaoBuscarPagamento(this.props.infoPagamento.idControlePagamento);
    trataMensagensErro(['Falha ao enviar os arquivos']);
  }

  incluirJuroseMultaNaMensagem = (response,dataPagamento) =>{
    const { mensagem } = { ...this.state };
    const {validadeCampos} = { ...this.state };

    validadeCampos.camposCalculadora = response ? true : false;
    mensagem.valorJuros = response ? response.valorTotalJuros : null;
    mensagem.valorMulta = response ? response.valorTotalMulta : null;
    mensagem.dataPagamento = dataPagamento ? dataPagamento : null;

    this.setState({
      mensagem: {
        ...mensagem,
      },
      validadeCampos: {
        ...validadeCampos,
      }
    });
  }

  // const textoDestaque = texto =>(<span style={{fontWeight:'600'}}>{texto}</span>);
  toggleCheckbox = (acaoToggle, nome) => {
    const acao = { MARCAR: 'marcar', DESMARCAR: 'desmarcar' };
    let changeObj = {};
    if (acaoToggle === acao.DESMARCAR) {
      changeObj.value = 0;
    } else {
      changeObj.value = 1;
    }
    this.handleChangeCheckbox(changeObj, nome);
  };

  checkedNaoReconhecoEstaCobranca = () => {
    return (this.state.naoReconhecoEstaCobranca && this.state.naoReconhecoEstaCobranca === 1);
  }

  checkedCancelarCobranca = () => {
    return (this.state.cancelarCobranca && this.state.cancelarCobranca === 1);
  }

  acaoNaoReconhecoEstaCobranca = () => {
    return this.checkedNaoReconhecoEstaCobranca() ? acao.DESMARCAR : acao.MARCAR;
  }

  acaoCancelarCobranca = (marcado) => {
    const acao = { MARCAR: 'marcar', DESMARCAR: 'desmarcar' };
    return marcado === 1 ? acao.DESMARCAR : acao.MARCAR;
  }

  montaFormDefesaPagamento = () => (
    <div>
      <Grid cols="4">
          <input
            value={this.state.naoReconhecoEstaCobranca}
            key="naoReconhecoEstaCobranca"
            label="Não reconheço esta cobrança."
            type="checkbox"
            checked={this.state.naoReconhecoEstaCobranca === 1}
            onClick={() => this.toggleCheckbox(this.acaoCancelarCobranca(this.state.naoReconhecoEstaCobranca), 'naoReconhecoEstaCobranca')}
            style={{ paddingLeft: '5px', position: 'relative', top: '25px', fontSize: '14px' }}
          />
          <span style={{ paddingLeft: '5px', position: 'relative', top: '24px', fontSize: '14px' }}>Não reconheço esta cobrança.</span>
      </Grid>
    </div>
  )

  montaFormAprovacaoReprovacaoPagamento = () => (
    <div>
      <Grid cols="4">
          <input
            value={this.state.cancelarCobranca}
            key="cancelarCobranca"
            label="Cancelar cobrança."
            type="checkbox"
            checked={this.state.cancelarCobranca === 1}
            onClick={() => this.toggleCheckbox(this.acaoCancelarCobranca(this.state.cancelarCobranca), 'cancelarCobranca')}
            style={{ paddingLeft: '5px', position: 'relative', top: '25px', fontSize: '14px' }}
            disabled={this.state.opcaoNovaMensagem === '11'}
          />
          <span style={{ paddingLeft: '5px', position: 'relative', top: '24px', fontSize: '14px' }}>Cancelar cobrança.</span>
      </Grid>
    </div>
  )

  montaFormDefesaPagamentoGRU = () => (
    <Grid cols="12">
      <Input
        itemList={this.state.listaGrusDoPagamento}
        label="Opção de pagamento"
        onChange={e => (this.handleTextChange(e, 'idGruNossoNumero'))}
        placeholder="Selecione o número da GRU"
        value={this.state.mensagem.idGruNossoNumero}
        custom
        required
      />
    </Grid>
  )

  verificaTamanhoInput = (tipoMensagem) => {
    let tamanho = { maxWidth: '450px', margin: 'auto' }; 
    if (tipoMensagem === '10') {
      tamanho = { maxWidth: '600px', margin: 'auto' };
    }
    return tamanho;
  }

  render() {
    if (this.filtrarTiposMensagem().length === 0) {
      return (<div> </div>)
    }
    
    return (
      <div style={{ backgroundColor: '#f8f9fa' , padding: '3px 0 3px 0'}}>
        { !(ehPapelObservadorPagamento(this.props.estadoFormulario.papelUsuarioLogado)) ?
          <div style={this.verificaTamanhoInput(this.state.opcaoNovaMensagem)}>
            <Input
              itemList={this.filtrarTiposMensagem()}
              label="Nova Mensagem"
              onChange={e => (this.handleComboTipoMensagemChange(e))}
              placeholder="Selecione o tipo de mensagem"
              value={this.state.opcaoNovaMensagem}
              custom
            />   
          </div>
        : '' }
        {this.state.opcaoNovaMensagem &&
        <div style={
        {
          maxWidth: '900px',
          margin: 'auto',
          backgroundColor: 'white',
          padding: '25px',
          marginBottom: '80px',
        }}
        >
          {/* descricao do motivo */}
          <div className="row" style={rowStyle}>
            <SimpleGrid>
              <Grid cols="12 12 12 12">
                <span>{this.state.opcaoNovaMensagem ? obterTipoMensagem(parseInt(this.state.opcaoNovaMensagem)).descricaoMotivo : ''}</span>
              </Grid>
            </SimpleGrid>
          </div>
          <div className="row" style={rowStyle}>
            <SimpleGrid>
              {this.state.opcaoNovaMensagem === '2' &&
              <Grid cols="12">
                <Input
                  currency
                  showMask={false}
                  label="Valor recebido identificado"
                  onChange={e => (this.handleTextChange(e, 'valorParcial'))}
                  onKeyUp={e => this.handleKeyUp(e, 'rendaMensalInicial')}
                  maxLength="12"
                  required
                  value={this.state.mensagem.valorParcial}
                />
              </Grid>
              }
              {this.state.opcaoNovaMensagem === '12' &&
                this.montaFormDefesaPagamentoGRU()
              }
              <Grid cols="12">
                <Input
                  cols="80"
                  componentClass="textarea"
                  label={this.mostraTextoJustificativa()}
                  maxlength="400"
                  onChange={e => (this.handleTextChange(e, 'textoMensagem'))}
                  rows="2"
                  required
                  value={this.state.mensagem.textoMensagem}
                  textarea
                />
              </Grid>
              <Grid cols="12">
                <Input
                  label="Email de contato:"
                  maxlength="100"
                  onChange={e => (this.handleTextChange(e, 'email'))}
                  required
                  value={this.state.mensagem.email}
                />
              </Grid>
              {this.state.opcaoNovaMensagem === '3' &&
                <Grid cols="12">
                  <Input
                    label="Data de Pagamento"
                    mask={Masks.date}
                    onChange={e => (this.handleTextChange(e, 'dataPagamento'))}
                    required
                    value={this.state.mensagem.dataPagamento}
                  />
                </Grid>
              }
              <Grid cols="12">
                <Input
                  label="Informações adicionais de contato"
                  maxlength="200"
                  onChange={e => (this.handleTextChange(e, 'informacoesContato'))}
                  value={this.state.mensagem.informacoesContato}
                />
              </Grid>
              {['4','15'].includes(this.state.opcaoNovaMensagem) &&
              <Grid cols="12">
                <CalculadoraPagamento
                  valorParcial={this.state.mensagem.valorParcial}
                  infoPagamento={this.props.infoPagamento}
                  handleChange={this.props.handleChange}
                  handleKeyUp={this.props.handleKeyUp}
                  incluirJuroseMultaNaMensagem={this.incluirJuroseMultaNaMensagem}
                  opcaoNovaMensagem={this.state.opcaoNovaMensagem}
                />
              </Grid>}
              {['9','10'].includes(this.state.opcaoNovaMensagem) &&
                <Grid cols="5">
                  <Input
                    disabled={this.state.opcaoNovaMensagem === '11' || this.state.naoReconhecoEstaCobranca === 1 || this.state.cancelarCobranca === 1}
                    currency
                    showMask={false}
                    label="Novo valor de cobrança."
                    onChange={e => (this.handleTextChange(e, 'valorCobrancaAtualizado'))}
                    onKeyUp={e => this.handleKeyUp(e, 'valorCobrancaAtualizado')}
                    maxLength="12"
                    value={this.state.mensagem.valorCobrancaAtualizado}
                    required={(this.state.opcaoNovaMensagem === '10' || this.state.opcaoNovaMensagem === '11') && this.state.cancelarCobranca === 0}
                  />
                </Grid>
              }
              {this.state.opcaoNovaMensagem === '9' &&
                this.montaFormDefesaPagamento()
              }
              {(this.state.opcaoNovaMensagem === '10') &&
                this.montaFormAprovacaoReprovacaoPagamento()
              }
              <Grid cols="12">
                <UploadArquivosMsg
                  arquivos={[...this.state.arquivos]}
                  estadoFormulario={this.state}
                  handleChange={e => this.handleArquivostChange(e)}
                  infoPagamento={this.props.estadoFormulario.infoPagamento}
                />
              </Grid>
            </SimpleGrid>
            
            <SimpleGrid>
              <Grid cols="12">
                <ProtectedItem allowedPermissions={pemissoesAcaoPrincipal}>
                  <Button
                    className="dtp-primary right"
                    disabled={!this.formularioProntoParaEnvio()}
                    title='Enviar'
                    onClick={this.handleSaveButton}
                    hint='Enviar mensagem'
                  />
                </ProtectedItem>
              </Grid>               
            </SimpleGrid>
          </div>
        </div>}
      </div>  

    );
  }
};

NovaMensagem.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleKeyUp: PropTypes.func.isRequired,
  incluirJuroseMultaNaMensagem: PropTypes.func,
  tipoControle: PropTypes.string.isRequired,
};

export default NovaMensagem;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/NovaMensagem.jsx